/** 封心官方渠道（旧 X @fxinflap 已封） */
export const OFFICIAL_X_URL = "https://x.com/Mariianiitha21";
export const OFFICIAL_X_HANDLE = "@Mariianiitha21";
export const OFFICIAL_TG_URL = "https://t.me/Flapfxin";
export const OFFICIAL_TG_HANDLE = "@Flapfxin";
